<template>
  <div class="table-box">
    <el-table
        :data="tableData"
        stripe
        v-loading="isLoading"
        :header-cell-style="{background:'#f2f2f2'}"
        style="border: 1px solid #ebeef5;">
      <el-table-column
          v-for="(tHead, thIndex) in tableHead"
          v-if="!tHead.operate"
          :key="'th-' + thIndex"
          :width="tHead.width"
          :prop="tHead.value"
          :label="tHead.label">
        <template slot-scope="scope">
          <div v-if="tHead.type=='image'">
            <img class="table-image table-image-avatar " :src="scope.row[tHead.value]" alt="客服头像">
          </div>
          <div v-else-if="tHead.type=='status'">
           <span v-if="scope.row[tHead.value] == 1" class="status-success">成功</span>
           <span v-else class="status-fail">失败</span>
          </div>
          <div v-else>
            {{scope.row[tHead.value]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-else :label="tHead.label" :width="tHead.width">
        <template slot-scope="scope">
          <button class="tb-btn" :class="'tb-btn-'+handler.type" v-for="(handler, index) in tableHandler"
                  :key="'handler'+ index"
                  @click="handleButton(handler.methods, scope.row)">{{handler.label}}</button>
        </template>
      </el-table-column>
    </el-table>

      <!--    分页-->

    <pagenations
        :total="total"
        :size="size"
        @pageHandler="pageOperate">
    </pagenations>
  </div>

</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'
  export default {
    name: 'tablebox',
    props:{
      /**
       * 表单数据
       */
      tableData:{
        type: Array,
        required:true,
      },
      /**
       * 表头
       */
      tableHead:{
        type: Array,
        required: true,
      },
      /**
       * 表的操作
       */
      tableHandler: {
        type: Array,
        default: () => []
      },
      total: {
        type: Number,
        default: () => 0
      },
      isLoading: {
        type: Boolean,
        default: () => false
      },
      size:{
        type:Number,
        default:() => 10
      },
	  delConfirmText:{
	    type:String,
	    default:() => '将要进行删除操作, 是否继续?'
	  },
    },
    components:{
      pagenations
    },
    data() {
      return {

      }
    },
    methods: {
      handleButton(methods, row){
        if(methods == "delMethods"){
          this.$confirm(this.delConfirmText, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$emit("handleButton",{"methods":methods,"row":row})
          }).catch(() => {

          });
        }else {
          this.$emit("handleButton",{"methods":methods,"row":row})
        }

      },
      pageOperate(val){
        this.$emit("pageHandler",val)
      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss">
.table-box{
  width: 100%;
  padding-top: 10px;
  .el-table{
    font-size: 12px;
    color: #666;
  }

  .table-image-avatar{
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;

  }
  .tb-btn{
    background: none;
    border: 1px solid #999999;
    color: #666;
    border-radius: 2px;
    font-size: 12px;
    width: 65px;
	padding: 0;
	line-height: 20px;
    cursor: pointer;
    outline: none;
    &.tb-btn-edit,&.tb-btn-operate{
      border-color: #428efe;
      color: #428efe;
    }
    &.tb-btn-del{
		
    }
	 &.tb-btn-delete{
		 border-color: #ff4e00;
		 color: #ff4e00;
	 }
  }
  .tb-btn + .tb-btn{
    margin-left: 10px;
  }
  .pageNations{
    text-align: right;
    padding-top: 22px;
  }
  .status-success{
    color: #428efe;
  }
  .status-fail{
    color: #ff4e00;
  }
}
</style>
